
/*

sohel  10/01/2022 2700753823 Global Field ->Download Configuration-> handle Error Toast Msg and Catagory Payload Changes
ashraf 10/10/2022 2700753823 fixed prepopulation issue in edit rate popup

*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {GLOBAL_FIELD} from '../../../constants/MicroServiceConstants';
import download from '../../../util/DownloadLink';

const initialData = {
  globalFieldData: {},
  globalFieldStatus: {},
  dropDownData: {},
  tableNameData: {},
  tableFieldNameData: {},
  globalFieldsData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  globalStatus: null,
  codeExistMessage: null,
};

const slice = createSlice({
  name: 'globalField',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.globalStatus = null;
    },
    postGlobalFieldData: (state, action) => {
      state.globalFieldStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.codeExistMessage = action.payload?.data?.message;
      state.successMsg = action.payload?.response;
      state.globalStatus = action.payload?.data?.status;
    },
    getTableNameData: (state, action) => {
      state.tableNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.globalStatus = null;
    },
    getTableFieldNameData: (state, action) => {
      state.tableFieldNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    fetchGlobalFields: (state, action) => {
      state.globalFieldsData = action.payload.response;
    },
    resetStatus: (state) => {
      state.globalFieldStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.codeExistMessage = null;
      state.globalStatus = null;
      state.printStatus = null;
    },
    printSuccess: (state, action) => {
      state.printStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchError,
  postGlobalFieldData,
  fetchGlobalFields,
  resetMsg,
  resetStatus,
  getTableNameData,
  getTableFieldNameData,
  printSuccess,
} = slice.actions;

export const postGlobalField = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${GLOBAL_FIELD}/save/globalfields`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postGlobalFieldData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getTableName = (tableSuffix) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${GLOBAL_FIELD}/find/all/galaxytablename/${tableSuffix}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTableNameData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getTableFieldName = (tableName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${GLOBAL_FIELD}/find/columnname/${tableName}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTableFieldNameData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchGlobalFieldNames = (globalfield) => {
  return (dispatch) => {
    httpPost(`${GLOBAL_FIELD}/search/${GLOBAL_FIELD}/${globalfield}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchGlobalFields(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetGlobalFieldStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const postGlobalFields = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/print/globalfield`, data)
      .then((data) => {
        if (data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data?.status && data?.status === 200) {
          dispatch(printGlobalField({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const printGlobalField = (payload, printData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/generateurlprintglobalfields`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printSuccess(printData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
